import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sso-redirect',
    templateUrl: './ssoRedirect.component.html',
    styleUrls: ['./ssoRedirect.component.css'],
    standalone: false
})
export class SsoRedirectComponent  {

}
